import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-technical-details',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DatePipe],
  templateUrl: './staff-order-detail-technical-details.component.html',
  styleUrl: './staff-order-detail-technical-details.component.scss',
})
export class StaffOrderDetailTechnicalDetailsComponent {
  readonly facade = inject(StaffOrderDetailFacade);
}
